"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileAddIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Large_svg_1 = __importDefault(require("./Large.svg"));
const Medium_svg_1 = __importDefault(require("./Medium.svg"));
const MediumFilled_svg_1 = __importDefault(require("./MediumFilled.svg"));
const Small_svg_1 = __importDefault(require("./Small.svg"));
/**
 * Standard profile add icon
 * See: https://www.figma.com/file/qPpy550VSNWIx9tBNcZJrG/SDS-WebC-Icons?node-id=1043%3A259
 */
function ProfileAddIcon(props) {
    switch (props.size) {
        case "SMALL":
            return (0, jsx_runtime_1.jsx)(Small_svg_1.default, {});
        case "MEDIUM":
            return props.style === "FILLED" ? (0, jsx_runtime_1.jsx)(MediumFilled_svg_1.default, {}) : (0, jsx_runtime_1.jsx)(Medium_svg_1.default, {});
        case "LARGE":
            return (0, jsx_runtime_1.jsx)(Large_svg_1.default, {});
    }
}
exports.ProfileAddIcon = ProfileAddIcon;
//# sourceMappingURL=ProfileAddIcon.js.map